import api from './api';

// The backend defaults to page=1, limit=10 when no pagination params are
// sent, and silently truncates the rest — it does NOT return everything.
// Categories are an admin-curated list, unlikely to ever exceed 100
// (the backend's own hard cap on `limit`), so requesting the max page
// size here is the pragmatic fix. If this list ever needs to grow past
// 100, switch to real Prev/Next pagination using the `pagination` object
// the backend already returns (currentPage, totalPages, hasNextPage, etc).
export const getAdminSupportCategories = async () => {
  const res = await api.get('/admin/support/categories', { params: { limit: 100 } });
  return res.data; // { categories, pagination }
};

export const createAdminSupportCategory = async (payload) => {
  // payload: { name, description, displayOrder }
  const res = await api.post('/admin/support/categories', payload);
  return res.data;
};

export const updateAdminSupportCategory = async (id, payload) => {
  const res = await api.patch(`/admin/support/categories/${id}`, payload);
  return res.data;
};

// Same pagination gap as categories — a category with more than 10
// questions was silently hiding the rest. Requesting limit=100 covers
// any realistic FAQ category size.
export const getAdminSupportQuestions = async (categoryId) => {
  const res = await api.get('/admin/support/questions', { params: { categoryId, limit: 100 } });
  return res.data; // { questions, pagination }
};

export const createAdminSupportQuestion = async (payload) => {
  // payload: { question, answer, categoryId, displayOrder, isActive, allowLiveSupport, contactEmail, contactPhone, resourceLink }
  const res = await api.post('/admin/support/questions', payload);
  return res.data;
};

export const updateAdminSupportQuestion = async (id, payload) => {
  const res = await api.patch(`/admin/support/questions/${id}`, payload);
  return res.data;
};

export const deleteAdminSupportQuestion = async (id) => {
  const res = await api.delete(`/admin/support/questions/${id}`);
  return res.data;
};